import axios from 'axios'
import Cookies from 'js-cookie'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import { ServiceAtom } from '../../recoil/atoms'

interface GetSiteGroupsResponse {
  siteGroups: {
    createdDate: string
    description: string | null
    groupId: number
    groupName: string
    serviceId: number
    sites: []
  }[]
  start: number
  status: number
  statusMessage: string
  totalCount: number
}

const useGetSiteGroups = () => {
  const accessToken = Cookies.get('LoginToken')
  const service = useRecoilValue(ServiceAtom)

  const fetcher = (url: string): Promise<GetSiteGroupsResponse> => axios.get(url).then((res) => res.data)

  const url = new URL(`${process.env.REACT_APP_API_DOMAIN}/1/Console/GetSiteGroupsWithSiteCount`)
  url.searchParams.append('accessToken', accessToken ?? '')
  url.searchParams.append('service_id', service.value)
  url.searchParams.append('orderField', '0')

  const { data, isLoading } = useSWR(() => accessToken && service.value && url.href, fetcher, {
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
    shouldRetryOnError: false,
  })
  return {
    siteGroups: data,
    siteGroupsLoading: isLoading,
  }
}

export default useGetSiteGroups
